import React from "react";
import Typography from "@material-ui/core/Typography";
import { connect } from "react-redux";
import { toggleSignUp } from "../../../../store/actions/user/User";

function SignIn(props) {
  const handleSignIn = () => {
    props.toggleSignUp(true);
  };

  return (
    <>
      <div style={{}}>
        {/* <Typography
          variant="h5"
          style={{
            color: "var(--darker)",
            marginBottom: ".5rem",
            textAlign: "left",
          }}
        >
          {"Sign In to place your order"}
        </Typography> */}
        <Typography component="p">
          New to Grospick? Sign up now to get started! Or log in to your
          existing account.
        </Typography>

        <div
          onClick={handleSignIn}
          style={{
            maxWidth: "250px",
            background: "var(--themegreen)",
            color: "var(--white)",
            borderRadius: "5px",
            cursor: "pointer",
            // display: "flex",
            margin: "15px auto",
            fontWeight: 500,
            padding: "10px 25px",
            userSelect: "none",
            "&:hover": {
              boxShadow: "1px 1px 2px #000000",
            },
          }}
        >
          Sign In
        </div>
      </div>
    </>
  );
}

const mapStateWithProps = (state) => ({
  auth: state.user.auth,
  userDetails: state.user.userDetails,
});
const mapDispatchToProps = (dispatch) => ({
  toggleSignUp: (isOpen) => dispatch(toggleSignUp(isOpen)),
});

export default React.memo(
  connect(mapStateWithProps, mapDispatchToProps)(SignIn)
);
